<div *ngIf="templatesMap" class="flex flex-col">
  <ng-container [ngTemplateOutlet]="templatesMap[dynamicFormModel.property.type]"
    [ngTemplateOutletContext]="{control: dynamicFormModel.formGroup.get(dynamicFormModel.property.name), property: dynamicFormModel.property, formGroup: dynamicFormModel.formGroup,showTitle: showTopLevelTitle}">
  </ng-container>
</div>

<ng-template [appNamedTemplate]="InstallationSchemaPropertyType.BOOLEAN" let-control="control" let-property="property">
  <div *ngIf="!sandbox || (sandbox && !property.default)" class="flex flex-col mb-0 setup">
    <label class="overline-font subheading fs-14 mb-8">{{ property.title | uppercase }}</label>
    <mat-slide-toggle color="primary" class="mb-16" disabled [checked]="control.value"></mat-slide-toggle>
  </div>
</ng-template>

<ng-template [appNamedTemplate]="InstallationSchemaPropertyType.STRING" let-control="control" let-property="property">
  <div *ngIf="!sandbox || (sandbox && !property.default)" class="flex flex-col mb-0 setup">
    <label class="overline-font subheading fs-14 mb-8">{{ property.title | uppercase }}</label>
    <div *ngIf="property?.updatedValue && property['x-edit'] === 'append'" class="mat-subtitle-2 blueprint-value fw-500 mb-16 overflow-wrap">{{ property['x-value-type'] === 'secret' && property?.displayValue ? '**********': property?.displayValue? property?.displayValue : '-'}}</div>
    <div *ngIf="!property?.updatedValue || property['x-edit'] !== 'append'" class="mat-subtitle-2 blueprint-value fw-500 mb-16 overflow-wrap">{{ property['x-value-type'] === 'secret' && control.value ? '**********': control.value? control.value : '-'}}</div>
  </div>
</ng-template>

<ng-template [appNamedTemplate]="InstallationSchemaPropertyType.SELECT" let-control="control" let-property="property">
  <div *ngIf="!sandbox || (sandbox && !property.default)" class="flex flex-col mb-0 setup">
    <label class="overline-font subheading fs-14 mb-8">{{ property.title | uppercase }}</label>
    <div class="mat-subtitle-2 blueprint-value fw-500 mb-16">{{ control.value? control.value : '-' }}</div>
  </div>
</ng-template>

<ng-template [appNamedTemplate]="InstallationSchemaPropertyType.DATE" let-control="control" let-property="property">
  <div *ngIf="!sandbox || (sandbox && !property.default)" class="flex flex-col mb-0 setup">
    <label class="overline-font subheading fs-14 mb-8">{{ property.title | uppercase }}</label>
    <div class="mat-subtitle-2 blueprint-value fw-500 mb-16">{{ control.value? (control.value | date:('dd MMM yyyy hh:mm')+ ' UTC') : '-' }}</div>
  </div>
</ng-template>

<ng-template [appNamedTemplate]="InstallationSchemaPropertyType.INTEGER" let-control="control" let-property="property">
  <div *ngIf="!sandbox || (sandbox && !property.default)" class="flex flex-col mb-0 setup">
    <label class="overline-font subheading fs-14 mb-8">{{ property.title | uppercase }}</label>
    <div class="mat-subtitle-2 blueprint-value fw-500 mb-16">{{ control.value? control.value : '-'  }}</div>
  </div>
</ng-template>

<ng-template [appNamedTemplate]="InstallationSchemaPropertyType.NUMBER" let-control="control" let-property="property">
  <div *ngIf="!sandbox || (sandbox && !property.default)" class="flex flex-col mb-0 setup">
    <label class="overline-font subheading fs-14 mb-8">{{ property.title | uppercase }}</label>
    <div class="mat-subtitle-2 blueprint-value fw-500 mb-16">{{ control.value? control.value : '-'  }}</div>
  </div>
</ng-template>

<ng-template [appNamedTemplate]="InstallationSchemaPropertyType.OBJECT" let-showTitle="showTitle" let-control="control"
  let-property="property" let-formGroup="formGroup">
  <div class="flex flex-row flex-wrap gap-4">
    <ng-container *ngFor="let nestedproperty of property.properties"
      [ngTemplateOutlet]="templatesMap[nestedproperty.type]" [ngTemplateOutletContext]="{
          control: formGroup.get(property.name).get(nestedproperty.name),
          property: nestedproperty,
          showTitle: true
        }"></ng-container>
  </div>
</ng-template>

<ng-template [appNamedTemplate]="InstallationSchemaPropertyType.ARRAY" let-control="control" let-property="property">
  <div *ngIf="!sandbox || (sandbox && !property.default)" class="flex flex-col mb-0 setup">
    <label class="overline-font subheading fs-14 mb-8">{{ property.title | uppercase }}</label>
    <div class="mat-subtitle-2 blueprint-value fw-500 mb-16">{{ control?.value?.join?.(', ') }}</div>
  </div>
</ng-template>
